import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/user-management/basic-user";

export const List = async (values) => {
  return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
};

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}


export const Edit = async (formData, id) => {
    return await axiosInstance(options).put(`${path}/${id}`, formData);
}


export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/${values}`)
}

export const Status = async (values,id) => {
    return await axiosInstance(options).patch(`${path}/status/${id}`, values)
}

export const profileVerify = async (values,id) => {
    return await axiosInstance(options).put(`${path}/profile-verified/${id}`,values)
}